import { getApiBaseUrl } from "../config";

export const REPLICATE_CONTESTACAO_STORAGE_KEY = "ikaro_replicate_contestacao";

function firstProductCode(job) {
  const raw = job?.code ?? job?.product_code ?? job?.service ?? "";
  return String(raw).split(",")[0].trim().toUpperCase();
}

function parseInputPayload(inputPayload) {
  if (!inputPayload) {
    return null;
  }
  if (typeof inputPayload === "object") {
    return inputPayload;
  }
  if (typeof inputPayload === "string") {
    try {
      const parsed = JSON.parse(inputPayload);
      return typeof parsed === "object" && parsed !== null ? parsed : null;
    } catch {
      return null;
    }
  }
  return null;
}

/** Linha da tabela (lista global ou jobs) com code/service/product_code. */
export function contestacaoJobAllowsRecreateFromRow(job) {
  if (!isReplicatableContestacaoProductCode(firstProductCode(job))) {
    return false;
  }
  const payload = parseInputPayload(job?.input_payload);
  return Boolean(payload?.files?.peticao_inicial?.token);
}

export function isReplicatableContestacaoProductCode(code) {
  if (!code) return false;
  if (code.includes("DOSSIE")) return false;
  return code === "DC_CONTESTACAO" || code === "DC_PROCON";
}

/**
 * Grava dados para reabrir a tela "Nova contestação" com os mesmos arquivos e campos de entrada.
 */
export function persistContestacaoJobForReplication(job) {
  const productCode = firstProductCode(job);
  if (!isReplicatableContestacaoProductCode(productCode)) {
    return false;
  }

  const payload = parseInputPayload(job?.input_payload);
  if (!payload) {
    return false;
  }

  const files = payload.files;
  const pet = files?.peticao_inicial;
  if (!pet?.token) {
    return false;
  }

  let customProfile = payload.custom_profile;
  if (typeof customProfile === "string") {
    try {
      customProfile = JSON.parse(customProfile);
    } catch {
      customProfile = null;
    }
  }

  const data = {
    product_code: productCode,
    job_name: job.job_name || "",
    snapshot: {
      nome_advogado: payload.nome_advogado ?? "",
      oab_advogado: payload.oab_advogado ?? "",
      empresa_defendida: payload.empresa_defendida ?? "",
      local: payload.local ?? "",
      data_documento: payload.data_documento ?? null,
      instrucoes_especificas: payload.instrucoes_especificas ?? "",
      regras: payload.regras ?? null,
      regras_internas: payload.regras_internas ?? null,
      regras_subsidios: payload.regras_subsidios ?? null,
      custom_profile:
        customProfile && typeof customProfile === "object" ? customProfile : null,
      modo_geracao: payload.modo_geracao ?? "standard",
    },
    files: {
      peticao_inicial: {
        token: pet.token,
        filename: pet.filename || "peticao.pdf",
      },
      subsidios: Array.isArray(files.subsidios)
        ? files.subsidios.map((s) => ({
            token: s.token,
            filename: s.filename || "subsidio.pdf",
          }))
        : [],
    },
  };

  try {
    sessionStorage.setItem(
      REPLICATE_CONTESTACAO_STORAGE_KEY,
      JSON.stringify(data),
    );
    return true;
  } catch (e) {
    console.error("replicateContestacaoJob: falha ao gravar sessionStorage", e);
    return false;
  }
}

export async function fetchContestacaoInputFileBlob(
  fileToken,
  authToken,
  apiBaseUrl = getApiBaseUrl(),
) {
  const downloadUrl = `${apiBaseUrl}/files/download?token=${encodeURIComponent(
    fileToken,
  )}&Servicename=${encodeURIComponent("DOCUMENT_CREATION")}`;

  const response = await fetch(downloadUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${authToken}`,
      accept: "application/octet-stream",
    },
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.blob();
}
